import { Row, Col, Card, Table, Button, Modal, Form, Input, Select, Checkbox, Spin, } from "antd";
import { useState, useEffect, useRef, useCallback } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import { getBranches, getClasses, getBelts } from "../../constants/API/API";
import useApi from "../../hooks/useApi";
const { TextArea } = Input;
const Search = Input.Search;
const { Option } = Select;

function PushNotification() {
  const { request } = useRequest();
  const [searchText, setSearchText] = useState("");
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [list, setList] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState();

  const columns = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "User Type",
      dataIndex: "userType",
      key: "userType",
    },
    {
      title: "Notification Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "User",
      render: (_, { user, allUser, userType }) => {
        return (
          <div>
            {allUser
              ? "All " + userType
              : user.map((obj) => obj.name).join(", ")
                ? user.map((obj) => obj.name).join(", ")
                : "NA"}
          </div>
        );
      },
    },
    {
      title: "Added On",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    // {
    //   title: "Action",
    //   render: (_, record) => {
    //     return (
    //       <Button className="tb-view" onClick={(e) => { window.location.assign(`/view-notification/${record._id}`) }
    //       }>
    //         <i class="fa fa-light fa-eye"></i>
    //         View
    //       </Button >
    //     )
    //   }
    // }
  ];

  const onSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setPagination({ current: 1 });
    fetchData({ current: 1, pageSize: pagination.pageSize });
  };

  const fetchData = (pagination, filters) => {
    setLoading(true);
    const filterActive = filters ? filters.isActive : null;
    request({
      url: `/admin/notification/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
        }&search=${searchText}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        console.log(data);
        setList(data.data.docs);
        setPagination((prev) => ({
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: data.data.totalDocs,
        }));
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error, Severty.ERROR);
      },
    });
  };

  const handleChange = (pagination, filters) => {
    setLoading(true);
    console.log(pagination, filters);
    fetchData(pagination, filters);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh]);

  return (
    <div className="tabled">
      <Row>
        <Col xs="24" md={24} lg={24} xl={24}>
          <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title="Push Notifications"
            extra={
              <>
                <Search
                  size="large"
                  placeholder="Search by Title"
                  onChange={onSearch}
                  value={searchText}
                  onPressEnter={onSearch}
                />
                <Button onClick={() => setVisible(true)}>
                  Add Notification
                </Button>
              </>
            }
          >
            <div className="table-responsive">
              <Table
                loading={loading}
                columns={columns}
                dataSource={list}
                pagination={pagination}
                onChange={handleChange}
                className="ant-border-space"
              />
            </div>
          </Card>
        </Col>
      </Row>
      {visible && (
        <AddFrom
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}
    </div>
  );
}

const AddFrom = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [selectType, setSelectType] = useState("all");
  const [selectUser, setSelectUser] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [userList, setUserList] = useState([]);
  const [branches, setBranches] = useState([]);
  const [classes, setClasses] = useState([]);
  const [branchId, setBranchId] = useState();
  const [classId, setClassId] = useState();

  const [selectAllUser, setSelectAllUser] = useState(false);
  const [triggersGraduationEligibility, setTriggersGraduationEligibility] = useState(false);
  const [activeUser, setActiveUser] = useState(false);

  const [belts, setBelts] = useState([])
  const [selectBelt, setSelectBelt] = useState([]);
  const [selectAllBelt, setSelectAllBelt] = useState(false);


  const shouldHideUserFilters =
    triggersGraduationEligibility ||
    selectBelt.length > 0 ||
    selectAllBelt ||
    activeUser;

  useApi({
    callback: getBelts,
    payload: {},
    dependencies: [refresh],
    shouldCallApi: true,
    onSuccess: ({ data }) => setBelts(data),
  });

  const handleSelectAllBelt = (e) => {
    const checked = e.target.checked;
    const allIds = belts.map((b) => b._id);

    setSelectAllBelt(checked);
    setSelectBelt(checked ? allIds : []);

    if (checked) {
      setSelectUser([]);
      setSelectAllUser(false);
    }
  };


  const handleBeltChange = (value) => {
    setSelectBelt(value);
    setSelectAllBelt(value.length === belts.length);

    if (value.length > 0) {
      setSelectUser([]);
      setSelectAllUser(false);
    }
  };



  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
  }, [data]);

  const PAGE_SIZE = 10;
  const [userPage, setUserPage] = useState(1);
  const [userTotal, setUserTotal] = useState(0);
  const [userSearch, setUserSearch] = useState("");
  const [userLoading, setUserLoading] = useState(false);
  const userSearchTimerRef = useRef(null);

  const fetchUserList = useCallback(
    ({ type = selectType, page = 1, search = "", append = false } = {}) => {
      if (type === "all" || !type) return;
      setUserLoading(true);
      let baseUrl =
        type === "users"
          ? `users?branchId=${branchId || ""}&classId=${classId || ""}`
          : "employees?type=branch";
      const connector = baseUrl.includes("?") ? "&" : "?";
      const url = `/common/${baseUrl}${connector}page=${page}&limit=${PAGE_SIZE}&search=${encodeURIComponent(
        search
      )}`;

      request({
        url,
        method: "GET",
        onSuccess: (res) => {
          const { data = [], total = 0 } = res?.data || {};
          setUserTotal(total);
          setUserList((prev) => (append ? [...prev, ...data] : data));
          setUserPage(page);
          setUserLoading(false);
        },
        onError: (error) => {
          console.log(error);
          setUserLoading(false);
          ShowToast(error, Severty.ERROR);
        },
      });
    },
    [selectType, branchId, classId, request]
  );

  useEffect(() => {
    if ((branchId || classId) && selectType && selectType !== "all") {
      fetchUserList({ type: selectType, page: 1, search: "", append: false });
    }
  }, [branchId, classId]);

  const handleSelectAll = (e) => {
    const allUserIds = userList.map((user) => user._id);
    setSelectUser(e.target.checked ? allUserIds : []);
    setSelectAll(e.target.checked);
  };

  const handleTypeChange = (value) => {
    setSelectType(value);
    setSelectUser([]);
    setUserSearch("");
    if (value !== "all") {
      fetchUserList({ type: value, page: 1, search: "", append: false });
    } else {
      setUserList([]);
    }
    setLoading(false);
  };

  const handleUserChange = (value) => {
    setSelectUser(value);
    setSelectAll(value.length === userList.length);
  };

  const handleUserSearch = (value) => {
    setUserSearch(value);
    if (userSearchTimerRef.current) clearTimeout(userSearchTimerRef.current);
    userSearchTimerRef.current = setTimeout(() => {
      fetchUserList({ type: selectType, page: 1, search: value, append: false });
    }, 400);
  };

  const handleUserPopupScroll = (e) => {
    const { target } = e;
    const isNearBottom =
      target.scrollTop + target.offsetHeight >= target.scrollHeight - 20;
    const hasMore = userList.length < userTotal;
    if (isNearBottom && hasMore && !userLoading) {
      fetchUserList({
        type: selectType,
        page: userPage + 1,
        search: userSearch,
        append: true,
      });
    }
  };

  useApi({
    callback: getBranches,
    payload: {},
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      const activeBranches = (data || []).filter((branch) => branch.isActive);
      setBranches(activeBranches);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  useApi({
    callback: getClasses,
    payload: {},
    dependencies: [],
    shouldCallApi: true,
    onSuccess: ({ data }) => {
      setClasses(data || []);
      setLoading(false);
    },
    onError: () => {
      setLoading(false);
    },
  });

  const onCreate = (values) => {
    setLoading(true);

    const isPush =
      triggersGraduationEligibility ||
      selectBelt.length > 0 ||
      selectAllBelt ||
      activeUser;

    const { title, message, type, notificationtype, classId, branchId } =
      values;
    const payload = {};
    payload.title = title;
    payload.type = type;
    payload.message = message;
    payload.branchId = branchId;
    payload.classId = classId;
    payload.userType = selectType ? selectType : "all";
    payload.selectUser = selectUser.length > 0 ? selectUser : [];
    payload.allUser = selectAll;
    payload.notificationtype = notificationtype;

    payload.triggersGraduationEligibility = triggersGraduationEligibility;
    payload.belts = selectBelt;
    payload.allBelts = selectAllBelt;
    payload.activeUser = activeUser;

    request({
      // url: `/admin/notification/add-notification`,
      url: isPush
        ? "/admin/notification/push-notification"
        : "/admin/notification/add-notification",
      method: "POST",
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          hide();
          refresh();
          ShowToast(data.message, Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <Modal
      open={show}
      title={`${data ? "Edit" : "Create"}`}
      okText="Ok"
      onCancel={hide}
      className="tab_modal"
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Form.Item
          name="type"
          label="Notification Type"
          rules={[
            { required: true, message: "Please Enter The Notification Type!" },
          ]}
          normalize={(v) => v?.trimStart()}
        >
          <Input placeholder="Enter Notification Type" />
          {/* <Select className="nottfy-add" placeholder="Select Type">
            <Option value="Updates or changes to platform policies">
              Updates or changes to platform policies
            </Option>
            <Option value="Promotional offers or discounts">
              Promotional offers or discounts
            </Option>
            <Option value="Important alerts or reminders">
              Important alerts or reminders
            </Option>
            <Option value="Feedback requests or surveys">
              Feedback requests or surveys
            </Option>
            <Option value="Order status updates">Order status updates</Option>
            <Option value="Payment reminders">Payment reminders</Option>
            <Option value="Service maintenance notifications">
              Service maintenance notifications
            </Option>
          </Select> */}
        </Form.Item>

        <Form.Item
          label="User Type"
          name="userType"
          rules={[{ required: true, message: "Please select the User Type!" }]}
        >
          <Select
            className="nottfy-add"
            placeholder="Select Type"
            onChange={handleTypeChange}
          >
            <Option value="employees">Employee</Option>
            <Option value="users">User</Option>
          </Select>
        </Form.Item>

        {selectType === "users" && (
          <>

            <Form.Item label="Select Belt (Optional)">
              <Checkbox
                checked={triggersGraduationEligibility}
                onChange={(e) =>
                  setTriggersGraduationEligibility(e.target.checked)
                }
              >
                Only Eligible User
              </Checkbox>

              <Checkbox checked={selectAllBelt} onChange={handleSelectAllBelt}>
                Select All Belts
              </Checkbox>

              <Checkbox
                checked={activeUser}
                onChange={(e) => {
                  setActiveUser(e.target.checked);
                  if (e.target.checked) {
                    setSelectUser([]);
                    setSelectAllUser(false);
                    setSelectBelt([]);
                    setSelectAllBelt(false);
                  }
                }}
              >
                Only Active Users
              </Checkbox>
              {!selectAllBelt && (
                <Select
                  placeholder="Selet Belts"
                  mode="multiple"
                  value={selectBelt}
                  onChange={handleBeltChange}
                >
                  {belts.map((b) => (
                    <Option key={b._id} value={b._id}>
                      {b.name}
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>

            {!shouldHideUserFilters && (
              <div>

                <Form.Item
                  label="Branch"
                  name="branchId"
                  rules={[{ required: true, message: "Please select the branch!" }]}
                >
                  <Select
                    className="nottfy-add"
                    placeholder="Select Branch"
                    onChange={(id) => setBranchId(id)}
                  >
                    {branches?.map((branch) => {
                      return (
                        <Option value={branch?._id} key={branch?._id}>
                          {branch?.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>

                <Form.Item
                  label="Class (Optional)"
                  name="classId"
                // rules={[{ required: true, message: "Please select the class!" }]}
                >
                  <Select
                    className="nottfy-add"
                    placeholder="Select Class"
                    onChange={(id) => setClassId(id)}
                  >
                    {classes?.map((cls) => {
                      return (
                        <Option value={cls?._id} key={cls?._id}>
                          {cls?.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>

              </div>

            )}

          </>
        )}

        {!shouldHideUserFilters && (

          <div>
            {selectType != "all" || selectType === null ? (
              <Form.Item
                label={`Select ${selectType}`}
                name="user"
              // rules={[
              //   { required: true, message: "Please input the  !" }
              // ]}
              >
                <Checkbox checked={selectAll} onChange={handleSelectAll}>
                  Select All
                </Checkbox>
                {!selectAll ? (
                  <Select
                    placeholder={`Select ${selectType}`}
                    mode="multiple"
                    className="select-show-inn"
                    value={selectUser}
                    onChange={handleUserChange}
                    showSearch
                    filterOption={false}
                    onSearch={handleUserSearch}
                    onPopupScroll={handleUserPopupScroll}
                    notFoundContent={
                      userLoading ? <Spin size="small" /> : "No records found"
                    }
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        {userLoading && userList.length > 0 && (
                          <div style={{ textAlign: "center", padding: "8px 0" }}>
                            <Spin size="small" />
                          </div>
                        )}
                        {!userLoading && userList.length > 0 && (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "4px 0",
                              color: "#999",
                              fontSize: 12,
                            }}
                          >
                            {userList.length} / {userTotal} loaded
                          </div>
                        )}
                      </>
                    )}
                  >
                    {userList.length > 0 &&
                      userList.map((item) => (
                        <Option key={item._id} value={item._id}>
                          {item.name}
                        </Option>
                      ))}
                  </Select>
                ) : null}
              </Form.Item>
            ) : null}
          </div>
        )}

        <Form.Item
          label="Title"
          name="title"
          normalize={(val) => val?.trimStart()}
          rules={[{ required: true, message: "Please Enter the Title!" }]}
        >
          <Input placeholder="Title" />
          {/* <Input type="textarea" /> */}
        </Form.Item>
        <Col span={24}>
          <Form.Item
            label="Message"
            normalize={(val) => val?.trimStart()}
            name="message"
            className="textarea-inn"
            rules={[{ required: true, message: "Please Enter the  Message!" }]}
          >
            <TextArea rows={4} placeholder="Message" />
            {/* <Input type="textarea" /> */}
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  );
};

export default PushNotification;
